export default {
  title: 'Funktionsflag',
  subtitle: 'Aktivér eller deaktivér platformfunktioner for {{company}}.',
  no_company: 'Vælg en restaurant for at administrere dens funktionsflag.',
  columns: {
    feature: 'Funktion',
    status: 'Status',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (direkte)',
      description:
        'Lad denne restaurant modtage PayPal-betalinger direkte på deres egen PayPal-konto. Slået til som standard for restauranter hos partnere, der faktureres af Foodamigos, hvor kundeservicegebyret også opkræves på disse betalinger, og platformens andel faktureres til partneren.',
    },
    vip_free_flyers: {
      name: 'Gratis flyers hver måned',
      description:
        'Send automatisk 500 reklameflyers hver måned til denne restaurant (standard: slået til for VIP- og Star-niveau).',
    },
    custom_store_seo: {
      name: 'Tilpasset butiks-SEO',
      description: 'Lad denne restaurant administrere de tilpassede SEO-indstillinger for sin onlinebutik.',
    },
    external_printer: {
      name: 'Ekstern kvitteringsprinter',
      description:
        'Lad denne restaurant tilslutte en netværkskvitteringsprinter til ordreterminal-appen i stedet for at printe på terminalens indbyggede printer.',
    },
    stripe_payment_element: {
      name: 'Stripe Payment Element-kassen',
      description:
        'Lad restaurantens eget Stripe-konto bestemme, hvilke betalingsmetoder der tilbydes ved kassen. Slå den kun til, når dens Stripe-platform har betalingsmetoderne for tilknyttede konti konfigureret.',
    },
  },
  toasts: {
    enabled: 'Funktion aktiveret.',
    disabled: 'Funktion deaktiveret.',
    error: 'Funktionen kunne ikke opdateres. Prøv igen.',
    load_error: 'Funktionsflag kunne ikke indlæses.',
  },
};
